import { colors } from "../../../common/colors";

export const styles = {
  errorText: {
    color: colors.farm_red600,
    fontSize: "0.75rem"
  },

  errorOnInputField: {
    backgroundColor: colors.farm_gray15,
    margin: "0",
    padding: "5px",
  },

  inputField: {
    backgroundColor: colors.farm_white,
    width: "100%"
  },
}
